// SahiKhoj site configuration.
// PLACEHOLDERS — replace the two values below before launch:
//   1. supportEmail: set the official support inbox once configured.
//   2. playStoreUrl: set the live Google Play listing URL; while null the
//      "Coming Soon on Google Play" placeholder button is rendered.
export const SITE = {
    name: "SahiKhoj",
    domain: "sahikhoj.com",
    url: "https://sahikhoj.com",
    tagline: "Sahi Khoj. Sahi Daam.",
    supportEmail: "support@sahikhoj.in",
    supportEmailIsPlaceholder: false,
    playStoreUrl: null,
};
